import Vue from 'vue'
import VueRouter from 'vue-router'
import batchOperation from '@/views/Home/batchOperation.vue'
import grouping from '@/views/Home/grouping.vue'
import selectGrop from '@/views/Home/selectGrop.vue'
import batchRenew from '@/views/Home/batchRenew.vue'

Vue.use(VueRouter)

const Home = [
    {
        path: '/batchOperation',
        name: 'BatchOperation',
        component: batchOperation
    },
    {
        path: '/grouping',
        name: 'Grouping',
        component: grouping
    },
    {
        path: '/selectGrop',
        name: 'SelectGrop',
        component: selectGrop
    },
    {
        path: '/batchRenew',
        name: 'BatchRenew',
        component: batchRenew
    },
]

export default Home
